import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { firebaseConfig } from './config'

Vue.config.productionTip = false

// Initialize Firebase
const firebase = initializeApp(firebaseConfig)
getAnalytics(firebase)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
